import { CalendarDays, Compass, MapPin, Martini, Users, Zap } from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURES = [
  {
    icon: Users,
    title: "Friend groups",
    body: "Organize your people into crews so the right friends know when you're heading out.",
  },
  {
    icon: Zap,
    title: "Smart invites",
    body: "One tap sends the invite to everyone who's likely down — no manual texting each person.",
  },
  {
    icon: MapPin,
    title: "Check-ins",
    body: "Drop a check-in at a bar so friends can see where you are and pull up in real time.",
  },
  {
    icon: CalendarDays,
    title: "Plans & events",
    body: "Make a plan for tonight or later, RSVP as going or interested, and keep everyone in sync.",
  },
  {
    icon: Martini,
    title: "Deals & specials",
    body: "Discover happy hours and specials at nearby bars and never miss a good night out.",
  },
  {
    icon: Compass,
    title: "Venue discovery",
    body: "Find bars, pubs and nightclubs near you instantly, sorted from closest to farthest.",
  },
];

export const Features = () => (
  <section id="features" data-testid="features-section" className="py-20 sm:py-28 px-6">
    <div className="max-w-6xl mx-auto">
      <Reveal className="text-center">
        <h2 className="font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl">
          Everything to get the crew out
        </h2>
        <p className="mt-4 text-base text-zinc-400 max-w-xl mx-auto">
          Built for spontaneous nights and the friends who never reply to the group chat.
        </p>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <Reveal key={f.title} delay={i * 0.06}>
              <article
                data-testid={`feature-card-${f.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group h-full rounded-2xl bg-[#121816] border border-white/10 p-7 hover:border-[#4FE3E0]/35 hover:bg-[#151C1A] transition-colors duration-300"
              >
                <Icon
                  className="w-6 h-6 text-[#4FE3E0] transition-transform duration-300 group-hover:scale-110"
                  strokeWidth={2.2}
                />
                <h3 className="mt-5 font-semibold text-white text-lg">{f.title}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{f.body}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
